var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"margin-top":"-20px"}},[_c('vs-tabs',{attrs:{"alignment":"fixed"}},[_c('vs-tab',{attrs:{"label":"Entregar guias a escuelas"}},[_c('div',[_c('EntregaGuiasVue')],1)]),_c('vs-tab',{attrs:{"label":"Listado de entregas escuelas"}},[_c('div',[_c('ListadoEntregasVue')],1)])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }